import { create } from 'zustand';

export type ModalKind =
  | 'newClient'
  | 'newProject'
  | 'newInvoice'
  | 'newQuote'
  | 'newService'
  | 'attachSubscription'
  | 'newVendor'
  | 'newTask'
  | 'newDeal'
  | 'uploadDoc'
  | 'newCourse'
  | 'newCandidate'
  | 'newBodyRental'
  | 'addCourseCandidate'
  | 'newVault'
  | 'newSAL'
  | 'newComm'
  | 'assignMember'
  | 'newRole'
  | 'newDeliverable'
  | 'taskDetail'
  | 'newMilestone'
  | 'newClientNote'
  | 'newContact'
  | 'newLesson'
  | 'newAssessment'
  | 'newUser'
  | 'password'
  | 'newIntegration'
  | 'export'
  | 'newCashEntry'
  | 'newRecurring'
  | 'newTax'
  | 'newPayable'
  | 'newEmployee'
  | null;

interface ModalState {
  kind: ModalKind;
  payload?: Record<string, unknown>;
  /** true durante l'animazione di uscita: i componenti applicano la classe --leaving */
  closing: boolean;
  open: (kind: Exclude<ModalKind, null>, payload?: Record<string, unknown>) => void;
  /** Avvia l'uscita: setta closing, poi smonta dopo l'animazione (~180ms) */
  close: () => void;
}

const EXIT_MS = 180;

export const useModalStore = create<ModalState>((set, get) => ({
  kind: null,
  payload: undefined,
  closing: false,
  open: (kind, payload) => set({ kind, payload, closing: false }),
  close: () => {
    const { kind, closing } = get();
    if (!kind || closing) return;
    // Fase 1: avvia l'animazione di uscita mantenendo il modale montato
    set({ closing: true });
    // Fase 2: smonta dopo l'animazione — MA solo se siamo ANCORA in chiusura.
    // Se nel frattempo è stato chiamato open() (es. transizione progetto→preventivo,
    // cliente→progetto), open() resetta closing:false: in quel caso NON smontare,
    // altrimenti il timeout chiuderebbe il modale appena aperto.
    setTimeout(() => {
      if (get().closing) set({ kind: null, payload: undefined, closing: false });
    }, EXIT_MS);
  },
}));

export function openModal(kind: Exclude<ModalKind, null>, payload?: Record<string, unknown>) {
  useModalStore.getState().open(kind, payload);
}
